import styled from 'styled-components'

export const Table = styled.table`
  & tr {
    border-bottom: 2px solid var(--color-terciary);
  }
  & tr > * {
    padding: 5px;
    text-align: center;
    &:not(:last-child) {
      border-right: 2px solid var(--color-terciary);
    }
  }
`
export const TableLink = styled.a`
  transition: all 0.2s;
  &:hover {
    color: blue;
  }
`
export const NavigationButton = styled.button`
  transition: all 0.2s;
  padding: 3px 8px;
  background: #bbb;
  border-radius: 10px;
  border: 1px solid black;
  &:active {
    background: #555 !important;
  }
  &:hover {
    background: #eee;
  }
`
export const NavigationContainer = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 20px;
  }
`
export const NavigationGroup = styled.div`
  display: flex;
  gap: 5px;
`
export const TableOptions = styled.div`
  display: flex;
  gap: 1vh;
  @media (max-width: 768px) {
    width: 100%;
  }
  @media (max-width: 400px) {
    flex-direction: column;
    & > * {
      width: 100%;
    }
  }
`
export const SearchElements = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 5px;
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
`
